export const mapDelta = (value, suffix = '%') => {
  if (!value && value !== 0) return '';
  return `${value > 0 ? '+' : ''}${value}${suffix}`;
};

export const deltaGrowth = (value) =>
  // eslint-disable-next-line no-nested-ternary
  value == null ? null : value > 0 ? true : value < 0 ? false : null;
